import {
  getAggregatedScoreApi,
  getTopGoalsApi,
  getFiltersApi,
  getTabularDataApi,
  getObjectiveStatusApi,
  getTimelineScoreApi,
  getGoalsInsightsGroupByIndividualDataOldApi,
  getGoalsInsightsGroupByIndividualDataApi,
  getGoalsInsightsGroupByGoalsDataApi,
} from 'api/analytics/goal';
import Task1 from 'models/task1';

import { SEARCH_TAG_TYPES, TEAM_TASKS_VIEW_TYPES } from 'constants/ProjectConstants';

import { getTeamTasksForListView, getTeamTasksStats } from 'services/task';

import { GroupByKeys, AggregatedScore } from './reviewHelper';

export const getFilters = () =>
  getFiltersApi().then((res) => ({
    ...res.entity,
    cohorts: res.entity.cohort,
    groupByKeys: res.entity.groupByKeys.map((key) => GroupByKeys.fromJSON(key)),
    splitByKeys: res.entity.splitByKeys || [],
  }));

// this is for group by objective.
/**
 * @deprecated 06-08-2024
 */
export const getAggregatedScore = ({ cohort, groupByKeys, splitByKeys, timeBounds }) =>
  getAggregatedScoreApi({ cohort, groupByKeys, splitByKeys, timeBounds }).then((res) =>
    res.entity.map((json) => AggregatedScore.fromJSON(json))
  );

/**
 * @deprecated 06-08-2024
 */
export const getTimelineScore = ({ parentUuid, cohort, groupByKeys, splitByKeys, timeBounds }) =>
  getTimelineScoreApi({
    parentUuid,
    cohort,
    groupByKeys,
    splitByKeys,
    timeBounds,
  }).then((res) => res.entity.map((json) => AggregatedScore.fromJSON(json)));

/**
 * @deprecated 06-08-2024
 */
export const getTopGoals = ({ cohort, groupByKeys, splitByKeys, orderType = 'DESC', limit = 3, timeBounds }) => {
  const orderBy = [
    {
      columnId: 'GOAL_PROGRESS_PERCENTAGE',
      orderType,
    },
  ];
  return getTopGoalsApi({
    cohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    limit,
    timeBounds,
  }).then((res) => res.entity.map((json) => Task1.fromJSON(json)));
};

/**
 * @deprecated 06-08-2024
 */
export const getObjectiveStatus = ({ parentUuid, cohort, groupByKeys, splitByKeys, timeBounds }) =>
  getObjectiveStatusApi({
    parentUuid,
    cohort,
    groupByKeys,
    splitByKeys,
    timeBounds,
  }).then((res) => res.entity);

export const getTabularData = ({
  selectedCohort = null,
  cohort,
  groupByKeys,
  splitByKeys,
  parentUuid,
  orderBy,
  timeBounds,
  attributeFilter,
  isExpandedViewRequired = false,
}) => {
  if (orderBy.columnId === null) orderBy = null;
  else orderBy = [orderBy];

  return getTabularDataApi({
    selectedCohort,
    cohort,
    groupByKeys,
    splitByKeys,
    parentUuid,
    orderBy,
    timeBounds,
    attributeFilter,
    isExpandedViewRequired,
  }).then((res) => res.entity);
};

export const fetchGoals = ({
  limit,
  offset,
  cohort,
  selectedCohort = null,
  timeBounds,
  tagId,
  employeeId,
  orderBy,
  resourceType = TEAM_TASKS_VIEW_TYPES.list,
  filters = [],
  isTeamHubView = false,
  objectiveTimeboundFilter,
  orderByWithFilterTagType,
  isPrivateGoalRequired,
  startTS,
  endTS,
  pageType = null,
}) => {
  const durationKey = 'LASTYEAR';
  const type = SEARCH_TAG_TYPES.goal;
  const tagType = isTeamHubView ? SEARCH_TAG_TYPES.team : SEARCH_TAG_TYPES.objectiveTimeBound;

  if (employeeId) {
    filters.push({
      type: 'NAME',
      operator: 'IN',
      value: employeeId,
    });
  }
  return getTeamTasksForListView({
    tagId: tagId || -1,
    tagType,
    durationKey,
    limit,
    offset,
    filters,
    type,
    cohort,
    selectedCohort,
    timeBoundPeriod: timeBounds?.[0] ?? null,
    resourceType,
    orderByParam: orderByWithFilterTagType?.filterTagType,
    order: orderByWithFilterTagType?.orderType,
    objectiveTimeboundFilter,
    isPrivateGoalRequired,
    startTS,
    endTS,
    pageType,
  });
};

/**
 * @deprecated 06-08-2024
 */
export const fetchGoalsCount = ({ cohort, timeBounds, tagId, employeeId }) => {
  const durationKey = 'LASTYEAR';
  const filters = [];
  const type = SEARCH_TAG_TYPES.goal;
  const tagType = SEARCH_TAG_TYPES.objectiveTimeBound;

  if (employeeId) {
    filters.push({
      type: 'NAME',
      operator: 'IN',
      value: employeeId,
    });
  }
  return getTeamTasksStats({
    tagId: tagId || -1,
    tagType,
    durationKey,
    filters,
    type,
    cohort,
    timeBounds,
  });
};

/*
  Individual API calls
*/
/**
 * @deprecated 06-08-2024
 */
export const getTopPerformers = ({ cohort, groupByKeys, splitByKeys, orderType = 'DESC', limit = 3, timeBounds }) => {
  const orderBy = [
    {
      columnId: 'GOAL_PROGRESS_PERCENTAGE',
      orderType,
    },
  ];

  return getTopGoalsApi({
    cohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    limit,
    timeBounds,
  }).then((res) => res.entity);
};

/**
 * @deprecated 06-08-2024
 */
export const getAggregatedScoreForIndividual = ({
  cohort,
  groupByKeys,
  splitByKeys,
  viewType = 'CHECKIN',
  timeBounds,
}) =>
  getAggregatedScoreApi({
    cohort,
    groupByKeys,
    splitByKeys,
    graphType: viewType,
    timeBounds,
  }).then((res) => res.entity.map((json) => AggregatedScore.fromJSON(json)));

export const getGoalsInsightsGroupByIndividualData = ({
  selectedCohort = null,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
}) =>
  getGoalsInsightsGroupByIndividualDataApi({
    selectedCohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
  }).then((res) => res.entity);

/**
 * @deprecated 06-08-2024
 */
export const getGoalsInsightsGroupByIndividualOldData = ({
  selectedCohort = null,
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
}) =>
  getGoalsInsightsGroupByIndividualDataOldApi({
    selectedCohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    timeBounds,
  }).then((res) => res.entity);

export const getGoalsInsightsGroupByGoalsData = async ({
  groupByKeys,
  splitByKeys,
  orderBy,
  timeBounds,
  attributeFilter,
  cohort,
  isHierarchyView,
  pageType,
  isTreeView,
}) => {
  try {
    const res = await getGoalsInsightsGroupByGoalsDataApi({
      groupByKeys,
      splitByKeys,
      orderBy,
      timeBounds,
      attributeFilter,
      cohort,
      isHierarchyView,
      pageType,
      isTreeView,
    });
    return res.entity;
  } catch (error) {
    console.error('Error fetching goals cascaded view data : ', error);
  }
};
